// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".select_box[data-v-44b92485] {\n  min-height: 28px;\n  widows: 200%;\n  border: 1px solid #dddfe5;\n  border-radius: 4px;\n  box-sizing: border-box;\n  padding: 4px 8px;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n.select_box[data-v-44b92485]:hover {\n  border: 1px solid #448ef7;\n}", ""]);
// Exports
module.exports = exports;
